<template>
  <div class="mainContent" v-if="value">
    <div v-for="field in fields" :key="field.name" class="mainContent__input">
      <div>
        <sc-tooltip v-if="field.tooltip" type="is-light" position="is-right" :label="field.tooltip">
          <sc-icon size="is-small" icon="info-circle" />
        </sc-tooltip>
      </div>
      <sc-field
        class="mainContent__input__field"
        :label="field.title"
        :message="(field.required && !value[field.name] && alreadyChecked) ? 'O campo é obrigatório.' : ''"
        :type="(field.required && !value[field.name] && alreadyChecked) ? 'is-danger' : ''">
        <sc-input :type="field.type" v-model="value[field.name]" :disabled="value.validated"></sc-input>
      </sc-field>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScField,
  ScInput,
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';

const { mapMutations, mapActions, mapState } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'input-fields',
  components: {
    ScButton,
    ScField,
    ScInput,
    ScTooltip,
    ScIcon,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      alreadyChecked: false,
    };
  },
  computed: {
    ...mapState(['appDetails']),
  },
  methods: {
    ...mapMutations(['nextStep', 'setLoading']),
    ...mapActions(['validateApp']),

    validateConfig(config) {
      this.alreadyChecked = true;

      for (const field of this.fields) {
        if (field.required && !config[field.name]) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContent {
  display: flex;
  gap: 40px;

  &__input {

    &__field {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/base/BaseForm.vue